module.exports = __webpack_public_path__ + "static/media/sj_bg.1bba1863.png";